import createContext from 'create-react-context';
var RowContext = createContext({});
export default RowContext;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_antd@3.15.2@antd/es/grid/RowContext.js
// module id = 294
// module chunks = 0